import { render, staticRenderFns } from "./Nosidebar.vue?vue&type=template&id=bb4f9c7a&"
import script from "./Nosidebar.vue?vue&type=script&lang=js&"
export * from "./Nosidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports